export default __webpack_public_path__ + "static/media/user2.49e65675.svg";